import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-3",
  name: "contact-info"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "text-strong" }, "Ihre Kontaktdaten", -1)
const _hoisted_3 = { class: "row form-row" }
const _hoisted_4 = { class: "col-lg-6 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "salutation-input"
}, "Anrede* ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "\"Bitte geben Sie eine Anrede ein!", -1)
const _hoisted_7 = { class: "row form-row" }
const _hoisted_8 = { class: "col-lg-6 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "first-name-input"
}, "Vorname* ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie ihren Vornamen an!", -1)
const _hoisted_11 = { class: "col-lg-6 mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "last-name-input"
}, "Nachname* ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie ihren Nachnamen an!", -1)
const _hoisted_14 = { class: "row form-row" }
const _hoisted_15 = { class: "col mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "email-input"
}, "E-Mail-Adresse* ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie eine gültige E-Mail-Adresse an!", -1)
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "text-strong" }, "Ihre Adresse", -1)
const _hoisted_20 = { class: "row form-row" }
const _hoisted_21 = { class: "col mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "street-input"
}, "Straße / Hausnumme* ", -1)
const _hoisted_23 = ["required"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie die Straße ihres Wohnorts an", -1)
const _hoisted_25 = { class: "row form-row" }
const _hoisted_26 = { class: "col-lg-6 mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "postal-input"
}, "Postleitzahl ", -1)
const _hoisted_28 = ["required"]
const _hoisted_29 = { class: "col-lg-6 mb-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "town-input"
}, "Ort ", -1)
const _hoisted_31 = ["required"]
const _hoisted_32 = { class: "mb-2 form-check" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-0",
  for: "checkbox-mail-quote"
}, " Bitte schicken Sie mir das Angebot per Post zu. ", -1)
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "text-strong" }, "Sonstiges", -1)
const _hoisted_36 = { class: "row form-row" }
const _hoisted_37 = { class: "col mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label mb-0",
  for: "message-input"
}, "Anmerkungen ", -1)
const _hoisted_39 = { class: "mb-2 form-check" }
const _hoisted_40 = {
  class: "form-check-label mb-0",
  for: "checkbox-tos"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Ich habe die Informationen in der ")
const _hoisted_42 = ["href"]
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" zur Datenverarbeitung bei Kontaktanfragen zur Kenntnis genommen.* ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte akzeptieren Sie unsere AGB!", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "small mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "* Pflichtfeld")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    class: _normalizeClass([{ 'was-validated': _ctx.formWasValidated }, "quote-form"]),
    onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args))),
    onSubmit: _cache[21] || (_cache[21] = _withModifiers(()=>{}, ["stop","prevent"]))
  }, [
    _createElementVNode("fieldset", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "salutation-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quoteRequestInfo.salutation) = $event)),
            class: "form-control",
            name: "salutation",
            placeholder: "Anrede",
            required: "",
            type: "text",
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 544), [
            [_vModelText, _ctx.quoteRequestInfo.salutation]
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            id: "first-name-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quoteRequestInfo.firstName) = $event)),
            class: "form-control",
            minlength: "2",
            name: "first-name",
            placeholder: "Ihr Vorname",
            required: "",
            type: "text",
            onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 544), [
            [_vModelText, _ctx.quoteRequestInfo.firstName]
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            id: "last-name-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quoteRequestInfo.lastName) = $event)),
            class: "form-control",
            minlength: "2",
            name: "last-name",
            placeholder: "Ihr Nachname",
            required: "",
            type: "text",
            onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 544), [
            [_vModelText, _ctx.quoteRequestInfo.lastName]
          ]),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            id: "email-input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.quoteRequestInfo.emailAddress) = $event)),
            class: "form-control",
            name: "email",
            pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
            placeholder: "Ihre E-Mail-Adresse",
            required: "",
            type: "email",
            onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 544), [
            [_vModelText, _ctx.quoteRequestInfo.emailAddress]
          ]),
          _hoisted_17
        ])
      ])
    ]),
    _createElementVNode("fieldset", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            id: "street-input",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.quoteRequestInfo.address.street) = $event)),
            required: _ctx.addressRequired,
            class: "form-control",
            minlength: "2",
            name: "street",
            placeholder: "Ihre Straße / Hausnumme",
            type: "text",
            onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 40, _hoisted_23), [
            [_vModelText, _ctx.quoteRequestInfo.address.street]
          ]),
          _hoisted_24
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("input", {
            id: "postal-input",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.quoteRequestInfo.address.postalCode) = $event)),
            required: _ctx.addressRequired,
            class: "form-control",
            name: "postal",
            placeholder: "Postleitzahl",
            type: "text",
            onKeyup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 40, _hoisted_28), [
            [_vModelText, _ctx.quoteRequestInfo.address.postalCode]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            id: "town-input",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.quoteRequestInfo.address.town) = $event)),
            required: _ctx.addressRequired,
            class: "form-control",
            name: "town",
            placeholder: "Ort",
            type: "text",
            onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 40, _hoisted_31), [
            [_vModelText, _ctx.quoteRequestInfo.address.town]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _withDirectives(_createElementVNode("input", {
          id: "checkbox-mail-quote",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.quoteRequestInfo.sendViaMail) = $event)),
          class: "form-check-input",
          name: "use-mail",
          type: "checkbox",
          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.quoteRequestInfo.sendViaMail]
        ]),
        _hoisted_33
      ])
    ]),
    _createElementVNode("fieldset", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _withDirectives(_createElementVNode("textarea", {
            id: "message-input",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.quoteRequestInfo.message) = $event)),
            class: "form-control",
            name: "message",
            placeholder: "Ihre Anmerkungen",
            rows: "2",
            onKeyup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
          }, null, 544), [
            [_vModelText, _ctx.quoteRequestInfo.message]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _withDirectives(_createElementVNode("input", {
          id: "checkbox-tos",
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tosAccepted) = $event)),
          class: "form-check-input",
          name: "tos",
          required: "",
          type: "checkbox",
          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.tosAccepted]
        ]),
        _createElementVNode("label", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("a", {
            href: _ctx.tosUrl,
            class: "",
            rel: "noopener",
            target: "_blank"
          }, "Datenschutzerklärung", 8, _hoisted_42),
          _hoisted_43
        ]),
        _hoisted_44
      ])
    ]),
    _hoisted_45
  ], 34))
}